$( document ).ready(function() {

  
  // declared
  var $cartItem;

  ///////////////////////////////////////////////
  // MAKE MONEY ///////////////////////////////////
  ///////////////////////////////////////////////
  function makeMoney(money){
    return newMoney = '$' + (money/100).toFixed(2);
  }

  ///////////////////////////////////////////////
  // RESET CART /////////////////////////////////
  ///////////////////////////////////////////////
  function resetCart() {
    $.getJSON('/cart.js', function(cart) {
      var totalItemsCount = 0;
      for (item in cart.items) {
        totalItemsCount = totalItemsCount + cart.items[item].quantity;
        var lineID = cart.items[item].id;
        var linePrice = cart.items[item].final_line_price;
        $('tr[data-id="'+lineID+'"]').find('.price--end').text(makeMoney(linePrice));
      }
      $('.totals__subtotal-value').text(makeMoney(cart.total_price) + ' USD');
      $('.cart-count-num').text(totalItemsCount);
    } );
  }

  ///////////////////////////////////////////////
  // QUANTITY BUTTONS ///////////////////////////
  ///////////////////////////////////////////////
  $('.quantity_btn').on('click', function(e) {
    e.preventDefault();
    var $cartItem = $(this).closest('tr');
    var variant_id = $cartItem.data('id');
    var quantity = '';
    var orr_quantity = parseInt($(this).closest('tr').find('.quantity__input').val());
    // figure out which btn was clicked
    if( $(this).hasClass('btn-plus')) {
      quantity = orr_quantity + 1;
    } else {
      if( orr_quantity === 1){
        // Don't let it go to 0.
      quantity = 1;
      } else {
      quantity = orr_quantity - 1;
      }
    }
    $(this).closest('tr').find('.quantity__input').val(quantity);
    // must be declaired first
    var itemsArray = [variant_id];
    var data = { updates: {} };
    data.updates[itemsArray[0]] = quantity;
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(response) { 
        resetCart(response);
        realCartCount();
      },
      error: function() {
        console.log("error");
      }
    });
  });

  
  ///////////////////////////////////////////////
  // REMOVE BUTTONS /////////////////////////////
  ///////////////////////////////////////////////
  $(document).on('click', '.remove-this-item', function(e) {
    let tr = $(this).closest('tr');
    let thisItemId = tr.data('id');
    itemsArray = [thisItemId];
    var qty = 0;
    var data = { updates: {} };
    for (i = 0; i < itemsArray.length; i++) {
      data.updates[itemsArray[i]] = qty;
    }
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(response) {
          realCartCount();
          tr.remove();
          resetCart();
        }
    });
    realCartCount();
    $.getJSON('/cart.js', function(cart) {
      if(cart.items.length == 0){
          window.location.href= '/cart';
      }
    });
  });
});